import styled from "styled-components";

export const Highlight = styled.span`
  /* text-decoration: Highlight;
  text-decoration-color: ${({ theme }) => theme.primary.color};
  text-decoration-thickness: 6px;
  text-Highlight-offset: 12px; */
  color: ${({ theme }) => theme.primary.color};
`;
